import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {grayscale, onyxLight} from '/theme/color/on.color';

export const hitSlopIndent = indent / 2;

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    marginHorizontal: indent,
  },
  text: {
    color: onyxLight,
  },
  time: {
    fontWeight: 'bold',
  },
  infoIcon: {
    marginLeft: indent / 4,
    fontSize: 16,
    color: grayscale,
  },
  infoButtonFocusRing: {
    borderWidth: 0,
    borderColor: 'transparent',
  },
});
